import { CookieKeys, getClientCookie, isServer } from '@finn/ui-utils/ssr';

export const getClosedUserGroupId = (): string | undefined => {
  if (isServer()) {
    return;
  }

  return getClientCookie(CookieKeys.CLOSED_USER_GROUP_ID);
};
